const url = 'https://stormy-badlands-31674.herokuapp.com/api/v1';

export default url;
